import { Component } from '@angular/core';
import { PlantsApi } from '../../../../../core/api/plants/plants-api.service';
import { roundNumber } from '../../../../../shared/utils/common.utils';
import { PlantsService } from '../../../plants/services/plants.service';
import { QuickHarvestForm } from '../../forms/quick-harvest.form';

@Component({
  selector: 'app-dashboard-log-weighted-harvest-dialog',
  templateUrl: './dashboard-log-weighted-harvest-dialog.component.html',
  styleUrl: './dashboard-log-weighted-harvest-dialog.component.scss',
})
export class DashboardLogWeightedHarvestDialogComponent {
  form = new QuickHarvestForm(this.plantsApi);

  constructor(
    private plantsApi: PlantsApi,
    private plantsService: PlantsService
  ) {}

  get amountHint(): string {
    return `${this.currentWeight} → ${this.updatedWeight} g`;
  }

  get currentWeight(): number {
    return this.form.plantsForm.plants?.harvestedWeight || 0;
  }

  get newWeight(): number {
    return this.form.controls.amountHarvested.value || 0;
  }

  get updatedWeight(): number {
    return roundNumber(this.currentWeight + this.newWeight);
  }

  logHarvest(): void {
    if (this.form.isValid) {
      this.plantsService.logWeightedHarvest(this.form.plantsForm.plants!, this.newWeight).subscribe(harvest => {
        if (harvest && this.form.plantsForm.plants) {
          this.form.plantsForm.plants.harvestedAmount += 1;
          this.form.plantsForm.plants.harvestedWeight += harvest.weight;
          this.form.plantsForm.plants.harvestStartDate = this.form.plantsForm.plants.harvestStartDate || harvest.date;
          this.form.plantsForm.plants.harvestEndDate = harvest.date;
        }
      });
    }
  }
}
